<script setup lang="ts">
import { useInputStore } from "@/PC/store/inputStore";
import { browserTimeZone } from "@/common/helpers/browserTimeZone";
import { getTimeZoneCity } from "@/common/helpers/timezoneUtils";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const { secondaryTimeZone } = storeToRefs(useInputStore())

const localCity = computed(() => getTimeZoneCity(browserTimeZone()))
const secondaryCity = computed(() => {
  if (!secondaryTimeZone.value) return null
  return getTimeZoneCity(secondaryTimeZone.value)
})
</script>

<template>
  <div class="city-labels" v-if="secondaryCity">
    <roboto class="city-label gray-2" :title="secondaryCity">{{ secondaryCity }}</roboto>
    <roboto class="city-label gray-1" :title="localCity">{{ localCity }}</roboto>
  </div>
</template>

<style scoped>
.city-labels {
  display: flex;
  gap: 4px;
  position: sticky;
  top: -16px;
  z-index: 10;
  background: var(--bg-sub-4, #f7f7f7);
  padding-bottom: 2px;
  width: calc(var(--hour-label-width) - var(--base-8px) - 15px);
}
.city-label {
  font-size: 10px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: var(--hour-label-width)
}
</style>
